export default __webpack_public_path__ + "static/media/react2.714d213d.PNG";